import http from './baseHttp.js'
import util from './util'
// post
var baseRequestData = {
  // 登录
  param_authn_authn_login: {
    // url: '/authn/authn/newLogin',
    url: '/authn/authn/v1/frontLogin',
    param: {
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      loginAccount: '', // 登录账号
      marketId: 28, // 市场id
      terminalType: 4, // 终端类型
      type: '', // 登录方式 1 ：账号密码登录 2 短信验证码登录
      // code: '', // 短信/邮箱验证码 false
      password: '', // 密码 false
      loginWay: 1 // 账号类型(1:手机号 2:邮箱)
    }
  },
  // 短信登录
  param_authn_authn_codeLogin: {
    // url: '/authn/authn/newLogin',
    url: '/authn/authn/v1/frontSimpleLoginForVerificationCode',
    param: {
      loginWay: 1, // 账号类型(1:手机号 2:邮箱)
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      loginAccount: '', // 登录账号
      terminalType: 4, // 终端类型
      code: '' // 短信/邮箱验证码 false
    }
  },
  // 注册 接口变更 2021-11-25
  param_registerCustomer: {
    url: '/register/register/v1/addFrontUser',
    param: {
      registerWay: 1, // 注册方式 （1:手机号注册 2:邮箱注册）
      loginAccount: '', // 登录账号
      marketId: 28, // 市场id
      lnvitationCode: '', // 邀请码
      code: '', // 短信验证码
      password: '' // 密码
      // createWay: 2, // 开户通道（1:管理后台 2:网上开户）
      // firmTypeId: 1, // 用户类型 （1:交易员 9:交易所）
      // firstMember: true,
      // lnvitationCodeMustFillIn: true
      // messageAuthentication: true,
      // userCode: '',//客户编码
      // userName: ''//客户名称
    }
  },
  // 登出
  param_logout: {
    // url: '/authn/authn/logout',
    url: '/authn/authn/v1/logout',
    param: {
      // sessionStr: '' //header
    }
  },
  // 发送短信验证码
  param_sendCaptcha: {
    url: '/authn/authn/sendCaptcha',
    param: {
      // firmId: '', // 用户id false
      id: '', // 短信模板编码id  // 2用户注册 38忘记密码 45重置密码 46手机验证码登录 47修改密码 50登录成功 51测试重置密码失败 52测试重置资金密码 100测试重置资金密码失败 101修改资金密码 35开户驳回 28开户通过
      loginAccount: '' //	账号
    }
  },
  // 修改手机号发送短信
  param_updateCellphoneSendMsg: {
    url: '/base-desk-manage/user/updateCellphoneSendMsg',
    param: {
      newCellphone: '' //	账号
    }
  },
  // 更换手机号
  param_updateCellphoneByUserIdNew: {
    url: '/base-desk-manage/user/updateCellphoneByUserIdNew',
    param: {
      newCellphone: '', //	账号
      code: '',
      pwd: ''
    }
  },
  // 校验短信验证码
  param_validCaptchaJson: {
    url: '/authn/authn/validCaptchaJson',
    param: {}
  },

  // 校验验证码
  param_validCaptcha: {
    url: '/authn/authn/validCaptcha',
    param: {
      captchaId: '', // 验证码序列号
      code: '' // 验证码
    }
  },
  // 查询审核信息
  param_findBaseUserAuditByUserId: {
    // url: '/base-desk-query/baseUserAudit/findBaseUserAuditByUserId',
    url: '/base-desk-query/baseUserAudit/v1/getBaseUserAudit',
    param: {}
  }
}

// get
var baseRequestDataGet = {
  // 获取图形验证码
  param_generateCaptcha: {
    url: '/authn/authn/generateCaptcha',
    param: {}
  }
}

const BaseApi = {
  /**
   * 通用登录请求
   * username 用户名
   * md5password 加密密码
   * verificationCode 验证码
   * verificationCodeId 验证码
   * marketId 市场
   * type 登录方式 1 ：账号密码登录 2 短信验证码登录
   * code: '', // 短信/邮箱验证码 false
   * password: '' // 密码 false
   */
  login(loginValue) {
    // const u = navigator.userAgent
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    // 1：Windows PC 客户端2：iOS 客户端3：android 客户端4：window Web端5：交易所管理后台
    // if (isiOS) {
    baseRequestData.param_authn_authn_login.param.terminalType = localStorage.getItem('equipmentFlag_PC') || 4
    // } else {
    //   baseRequestData.param_authn_authn_login.param.terminalType = '3'
    // }
    baseRequestData.param_authn_authn_login.param.loginAccount =
      loginValue.loginAccount
    baseRequestData.param_authn_authn_login.param.captchaCode =
      loginValue.captchaCode
    baseRequestData.param_authn_authn_login.param.captchaId =
      loginValue.captchaId
    baseRequestData.param_authn_authn_login.param.marketId =
      loginValue.marketId || 28
    baseRequestData.param_authn_authn_login.param.type = 1
    if (loginValue.code) {
      baseRequestData.param_authn_authn_login.param.code = loginValue.code
    }
    baseRequestData.param_authn_authn_login.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + loginValue.password
    )

    return http.postFront(baseRequestData.param_authn_authn_login)
  },
  codeLogin(loginValue) {
    // const u = navigator.userAgent
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    // 1：Windows PC 客户端2：iOS 客户端3：android 客户端4：window Web端5：交易所管理后台
    // if (isiOS) {
    baseRequestData.param_authn_authn_codeLogin.param.terminalType = localStorage.getItem('equipmentFlag_PC') || 4
    // } else {
    //   baseRequestData.param_authn_authn_codeLogin.param.terminalType = '3'
    // }
    baseRequestData.param_authn_authn_codeLogin.param.loginAccount =
      loginValue.loginAccount
    baseRequestData.param_authn_authn_codeLogin.param.captchaCode =
      loginValue.captchaCode
    baseRequestData.param_authn_authn_codeLogin.param.captchaId =
      loginValue.captchaId
    baseRequestData.param_authn_authn_codeLogin.param.code = loginValue.code
    baseRequestData.param_authn_authn_codeLogin.param.marketId = loginValue.marketId || 28
    // baseRequestData.param_authn_authn_codeLogin.param.type = 1
    return http.postFront(baseRequestData.param_authn_authn_codeLogin)
  },

  /**
   * 注册
   * code: '',//短信验证码
   * createWay: 2,//开户通道（1:管理后台 2:网上开户）
   * firmTypeId: 1,//用户类型 （1:交易员 9:交易所）
   * lnvitationCode: '',//邀请码
   * loginAccount: '',//登录账号
   * marketId: 28,//市场id
   * password: '',//密码
   * registerWay: 1,//注册方式 （1:手机号注册 2:邮箱注册）
   * // firstMember: true,
   * // lnvitationCodeMustFillIn: true,
   * // messageAuthentication: true,
   * // userCode: '',//客户编码
   * // userName: ''//客户名称
   */
  registerCustomer(registerValue) {
    baseRequestData.param_registerCustomer.param.code = registerValue.code
    baseRequestData.param_registerCustomer.param.createWay = 2
    baseRequestData.param_registerCustomer.param.firmTypeId = 1
    baseRequestData.param_registerCustomer.param.registerWay = 1
    baseRequestData.param_registerCustomer.param.lnvitationCode =
      registerValue.lnvitationCode // 邀请码
    baseRequestData.param_registerCustomer.param.loginAccount =
      registerValue.loginAccount
    baseRequestData.param_registerCustomer.param.marketId =
      registerValue.marketId || 28
    baseRequestData.param_registerCustomer.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + registerValue.password
    )

    return http.postFront(baseRequestData.param_registerCustomer)
  },
  /**
   * 登出
   */
  logout() {
    return http.postFront(baseRequestData.param_logout)
  },

  // 校验短信验证码
  validCaptchaJson(sendValue) {
    baseRequestData.param_validCaptchaJson.param.captchaId = sendValue.captchaId
    baseRequestData.param_validCaptchaJson.param.code = sendValue.code

    return http.postFront(baseRequestData.param_validCaptchaJson)
  },

  /**
     * 发送短信验证码
     * firmId:'', //用户id false
     * id:'', // 短信模板编码id
     * loginAccount:'' //	账号
     */
  sendCaptcha(sendValue) {
    // baseRequestData.param_sendCaptcha.param.firmId = firmId
    baseRequestData.param_sendCaptcha.param.id = sendValue.id
    baseRequestData.param_sendCaptcha.param.loginAccount = sendValue.loginAccount
    baseRequestData.param_sendCaptcha.param.code = '76ff9bee27790118a09fa33096fda87f'

    return http.postFront(baseRequestData.param_sendCaptcha)
  },
  updateCellphoneSendMsg(sendValue) {
    baseRequestData.param_updateCellphoneSendMsg.param.newCellphone = sendValue.newCellphone

    return http.postFront(baseRequestData.param_updateCellphoneSendMsg)
  },
  updateCellphoneByUserIdNew(sendValue) {
    baseRequestData.param_updateCellphoneByUserIdNew.param.newCellphone = sendValue.newCellphone
    baseRequestData.param_updateCellphoneByUserIdNew.param.code = sendValue.code
    baseRequestData.param_updateCellphoneByUserIdNew.param.pwd = util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password)

    return http.postFront(baseRequestData.param_updateCellphoneByUserIdNew)
  },
  /**
   * 获取图形验证码
   */
  generateCaptcha() {
    return http.getNewPath2(baseRequestDataGet.param_generateCaptcha)
  },
  /**
   * 查询审核信息
   * userId header
   */
  findBaseUserAuditByUserId() {
    return http.postFront(baseRequestData.param_findBaseUserAuditByUserId)
  }
}

export default BaseApi
